(function ($, Drupal) {
    Drupal.behaviors.breadcrumbs = {
        attach: function (context, settings) {
            $("#block-breadcrumbs ol").map(function (idx, breadcrumb) {
                let $breadcrumb = $(breadcrumb);

                if ($breadcrumb.children().length >= 4) {
                    let detached_children = $breadcrumb.children().slice(1, -2).detach();
                    let showText = Drupal.t("Show all breadcrumbs");
                    let expand_breadcrumb = $('<li><a href="" title="'+showText+'" aria-label="'+showText+'" role="button">...</a></li>');

                    expand_breadcrumb.click(function (event) {
                        event.preventDefault();
                        $breadcrumb.children().slice(1, -2).remove();
                        $breadcrumb.children().first().after(detached_children);
                    });

                    expand_breadcrumb.on('keydown.breadcrumb', function(e){
                      if(e.key === " " || e.code === "Space"){
                        e.preventDefault();
                        expand_breadcrumb.click();
                        expand_breadcrumb.off('keydown.breadcrumb');
                      }
                    });

                    $breadcrumb.children().first().after(expand_breadcrumb);
                }
            });
        }
    };
}(jQuery, Drupal));
